const features = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Upfront Pricing',
    description: 'No hidden fees or surprises. We give you an honest quote before we start.'
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Licensed & Insured',
    description: 'Fully licensed and insured for your peace of mind and protection.'
  },
  {
    icon: 'ri-time-line',
    title: 'Fast Response',
    description: 'Same-day and next-day service available. We work on your schedule.'
  },
  {
    icon: 'ri-leaf-line',
    title: 'Eco-Friendly',
    description: 'We recycle and donate whenever possible to minimize landfill waste.'
  }
];

export default function WhyChooseUs() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/507691d57f07f6ca6b58767720cb50e2.jpg"
          alt="Waste Management Facility"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3D3225] rounded-full mb-6">
              <i className="ri-star-line text-[#D4AF37]"></i>
              <span className="text-[#C4A574] text-sm font-medium tracking-wider">WHY CHOOSE US</span>
            </div>

            <h3 className="font-['Orbitron'] text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
              The <span className="text-[#D4AF37]"><span className="font-['Cinzel']">A</span>&H</span> Difference
            </h3>

            <p className="text-gray-300 text-lg mb-10 leading-relaxed">
              When you choose A&H Junk Removal, you&apos;re choosing a team that treats every job like it&apos;s 
              for family. We show up on time, work hard, and leave your space cleaner than we found it.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#D4AF37]/10 rounded-lg border border-[#D4AF37]/30">
                    <i className={`${feature.icon} text-2xl text-[#D4AF37]`}></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">{feature.title}</h4>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Stats Card */}
          <div className="bg-black/60 backdrop-blur-sm rounded-2xl border border-gray-800 p-8 lg:p-12">
            <div className="text-center mb-8">
              <p className="text-[#D4AF37] text-sm font-medium tracking-wider mb-2">TRUSTED BY FAMILIES</p>
              <h4 className="font-['Orbitron'] text-3xl font-bold text-white">Our Commitment</h4>
            </div>

            <div className="space-y-6">
              <div className="flex items-center justify-between p-4 bg-[#D4AF37]/5 rounded-xl border border-[#D4AF37]/20">
                <div className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-2xl text-[#D4AF37]"></i>
                  <span className="text-white">On-Time Arrival</span>
                </div>
                <span className="text-[#D4AF37] font-bold">100%</span>
              </div>

              <div className="flex items-center justify-between p-4 bg-[#D4AF37]/5 rounded-xl border border-[#D4AF37]/20">
                <div className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-2xl text-[#D4AF37]"></i>
                  <span className="text-white">Customer Satisfaction</span>
                </div>
                <span className="text-[#D4AF37] font-bold">100%</span>
              </div>

              <div className="flex items-center justify-between p-4 bg-[#D4AF37]/5 rounded-xl border border-[#D4AF37]/20">
                <div className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-line text-2xl text-[#D4AF37]"></i>
                  <span className="text-white">Eco-Friendly Disposal</span>
                </div>
                <span className="text-[#D4AF37] font-bold">100%</span>
              </div>

              <div className="flex items-center justify-between p-4 bg-[#3D3225]/50 rounded-xl border border-[#C4A574]/30">
                <div className="flex items-center gap-3">
                  <i className="ri-heart-line text-2xl text-[#C4A574]"></i>
                  <span className="text-white">Family Values</span>
                </div>
                <span className="text-[#C4A574] font-bold">Always</span>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800 text-center">
              <p className="text-gray-400 italic">
                &quot;We treat every customer like family.&quot;
              </p>
              <p className="text-[#D4AF37] font-semibold mt-2">— The A&H Team</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
